import { render, staticRenderFns } from "./lklOpening.vue?vue&type=template&id=447392e9&scoped=true&"
import script from "./lklOpening.vue?vue&type=script&lang=js&"
export * from "./lklOpening.vue?vue&type=script&lang=js&"
import style0 from "./lklOpening.vue?vue&type=style&index=0&id=447392e9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447392e9",
  null
  
)

export default component.exports